import React from 'react';
import classnames from 'classnames';
import styles from './avatar.css';

interface AvatarProps {
  /** User initials to display inside the avatar when there is no image */
  initials: string;
  /** URL to the image to display on the avatar */
  image?: string;
  /** Adds additional classes to the component. */
  className?: string;
  /** Provides a data-testid */
  'data-testid'?: string;
}

/**
 * Avatar Component
 *
 * @param {AvatarProps} props
 *
 * @returns JSX.ELEMENT
 */
export const Avatar = ({ className, initials, image, 'data-testid': dataTestid }: AvatarProps) => {
  const avatarClasses = classnames(styles.avatar, className);
  const initialsClasses = classnames({
    [styles.initials]: true,
    [styles.initialsHidden]: image
  });
  return (
    <div className={avatarClasses} data-testid={dataTestid}>
      <div className={initialsClasses}>{initials}</div>
      {image && <img src={image} className={styles.image} />}
    </div>
  );
};

export default Avatar;
